import classNames from 'classnames'
import React from 'react'
import {Button, ButtonPriority} from 'wix-ui-tpa/cssVars'
import {SecondaryButtonProps} from './interfaces'
import {classes} from './secondary-button.st.css'

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  className,
  dataHook,
  narrowerButton,
  children,
}) => (
  <Button
    upgrade
    priority={ButtonPriority.basicSecondary}
    className={classNames(classes.root, className, {
      [classes.narrowerButton]: narrowerButton,
    })}
    onClick={onClick}
    data-hook={dataHook}
  >
    {children}
  </Button>
)
